import { ENTSWindow,  } from './ENTSWindow.js';
import {DomainEvent} from "@cube/tracking-library-api";

declare const window: ENTSWindow;

export const track = (data: DomainEvent) => {
  if (!window.CubeDataLayer) {
    window.CubeDataLayer = [];
  }
  window.CubeDataLayer.push(data);
};
